import { User, UserType } from 'store/interfaces';

export function getUserRegistrationLocation(user: User) {
  if (!user) {
    return '';
  }

  if (user.type === UserType.external) {
    return [user.registrationCity, user.registrationCountry]
      .filter(Boolean)
      .join(', ');
  }

  return '';
}
